<template>
  <div class="privacy-content">
    <h1 class="privacy-title">Privatumo politika</h1>
    
    <section class="privacy-section">
      <h2 class="privacy-section-title">1. Įmonės informacija</h2>
      <div class="privacy-info">
        <p><strong>Įmonės kodas:</strong> 304945461</p>
        <p><strong>PVM mokėtojo kodas:</strong> LT100012115013</p>
        <p><strong>Adresas:</strong> Stoties g. 12, Jiezno Kolonijų k., LT-59421 Prienų r.</p>
        <p><strong>Mobilus telefonas:</strong> <a href="tel:+37061692311">+370 616 92311</a></p>
        <p><strong>Vadovo telefonas:</strong> <a href="tel:+37069814364">+370 698 14364</a></p>
        <p><strong>El. pašto adresas:</strong> <a href="mailto:info@arunvilkasa.lt">info@arunvilkasa.lt</a></p>
        <p><strong>Tinklalapis:</strong> <a href="http://arunvilkasa.lt" target="_blank">http://arunvilkasa.lt</a></p>
      </div>
    </section>

    <section class="privacy-section">
      <h2 class="privacy-section-title">2. Asmens duomenų tvarkymas</h2>
      <p>Mes renkame ir tvarkome asmens duomenis tik būtiniems tikslams:</p>
      <ul>
        <li>Susisiekti su klientais dėl paslaugų užsakymo</li>
        <li>Pateikti paslaugų pasiūlymus</li>
        <li>Vykdyti sutartis ir teikti paslaugas</li>
        <li>Vykdyti teisės aktų nustatytus įsipareigojimus</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2 class="privacy-section-title">3. Renkami duomenys</h2>
      <p>Gali būti renkami šie asmens duomenys:</p>
      <ul>
        <li>Vardas, pavardė</li>
        <li>Kontaktinė informacija (telefonas, el. paštas)</li>
        <li>Adresas (jei reikia)</li>
        <li>Kita informacija, kurią pateikiate susisiekdami su mumis</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2 class="privacy-section-title">4. Duomenų saugojimas</h2>
      <p>Asmens duomenis saugome tik tiek laiko, kiek reikia paslaugų teikimo tikslams arba pagal teisės aktų reikalavimus.</p>
    </section>

    <section class="privacy-section">
      <h2 class="privacy-section-title">5. Jūsų teisės</h2>
      <p>Turite teisę:</p>
      <ul>
        <li>Žinoti, kokie jūsų asmens duomenys tvarkomi</li>
        <li>Reikalauti pataisyti netikslius duomenis</li>
        <li>Reikalauti ištrinti duomenis</li>
        <li>Prieštarauti duomenų tvarkymui</li>
        <li>Reikalauti apriboti duomenų tvarkymą</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2 class="privacy-section-title">6. Trečiųjų šalių paslaugos</h2>
      <p>Jei naudojame „Google Maps", užkrovus žemėlapį gali būti siunčiamos užklausos į „Google" serverius. Žemėlapį rodome tik gavę Jūsų sutikimą.</p>
    </section>

    <section class="privacy-section">
      <h2 class="privacy-section-title">7. Susisiekite su mumis</h2>
      <p>Dėl klausimų apie asmens duomenų tvarkymą susisiekite:</p>
      <p>
        <strong>El. paštas:</strong> <a href="mailto:info@arunvilkasa.lt">info@arunvilkasa.lt</a><br>
        <strong>Telefonas:</strong> <a href="tel:+37061692311">+370 616 92311</a>
      </p>
    </section>

    <section class="privacy-section">
      <p class="privacy-updated">Paskutinį kartą atnaujinta: {{ currentYear }} m.</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.privacy-content {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.7;
  color: #333;
}

.privacy-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 2rem;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #dc3545;
}

.privacy-section {
  margin-bottom: 30px;
}

.privacy-section-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 15px;
}

.privacy-info {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #dc3545;
}

.privacy-info p {
  margin: 8px 0;
}

.privacy-info a {
  color: #dc3545;
  text-decoration: none;
}

.privacy-info a:hover {
  text-decoration: underline;
}

.privacy-content ul {
  padding-left: 25px;
}

.privacy-content li {
  margin-bottom: 8px;
}

.privacy-updated {
  font-size: 0.9rem;
  color: #6c757d;
  font-style: italic;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}
</style>


